import fetch from '../apiconfig/index'
// 用户登陆
export function Login(params) {
    return fetch.post(`/api/User/Login/?t=`+new Date().getTime(), params)
}

// 注销用户
export function Logout(params) {
    return fetch.get(`/api/User/Logout/?t=`+new Date().getTime(), params)
}

/* ==============================账号设置============================== */
// 修改账号密码
export function NewPwd(params) {
    return fetch.post(`/api/public/User/NewPwd/?t=`+new Date().getTime(), params)
}
//获取手机号信息
export function GetPhone(params) {
    return fetch.get(`/api/public/User/GetPhone/?t=`+new Date().getTime(), params)
}
//修改新手机号
export function NewPhone(params) {
    return fetch.post(`/api/public/User/GetPhone/?t=`+new Date().getTime(), params)
}


/* ==============================点评系统============================== */
// 获取点评列表
export function GetDiscussList(params) {
    return fetch.get(`/api/public/Dis/GetDiscussList/?t=`+new Date().getTime(), params)
}
// 添加点评信息
export function AddDiscuss(params) {
    return fetch.post(`/api/public/Dis/AddDiscuss/?t=`+new Date().getTime(), params)
}
/* ==============================留言管理============================== */
// 获取留言列表
export function GetExpTalkList(params) {
    return fetch.get(`/api/public/Talk/GetExpTalkList/?t=`+new Date().getTime(), params)
}
// 添加留言信息
export function AddExpTalk(params) {
    return fetch.post(`/api/public/Talk/AddExpTalk/?t=`+new Date().getTime(), params)
}
// 添加回复留言信息
export function AddTalkRe(params) {
    return fetch.post(`/api/public/Talk/AddTalkRe/?t=`+new Date().getTime(), params)
}
/* ==============================仿真实验学习资料管理============================== */

// 获取楼栋列表-搜索用
export function GetAllBuild(params) {
    return fetch.get(`/api/public/General/GetBuild/?t=`+new Date().getTime(), params)
}
// 获取楼层列表-搜索用
export function GetFloorArr(params) {
    return fetch.get(`/api/public/General/GetFloorArr/?t=`+new Date().getTime(), params)
}
// 获取实验室列表/api/public/YuYue/GetRoomList/
export function GetRoomList(params) {
    return fetch.get(`/api/public/YuYue/GetRoomList/?t=`+new Date().getTime(), params);
}
// 获取实验室信息
export function GetRoomById(params) {
    return fetch.get(`/api/public/YuYue/GetRoomById/?t=`+new Date().getTime(), params);
}

// 获取实验室所有设备列表
export function GetEquipmentByRoomId(params) {
    return fetch.get(`/api/public/YuYue/GetEquipmentAll/?t=`+new Date().getTime(), params);
}
// 获取实验室可用设备列表/api/public/YuYue/GetRoomEquSbState/
export function GetEquipmentUsable(params) {
    return fetch.get(`/api/public/YuYue/GetRoomEquSbState/?t=`+new Date().getTime(), params);
}
//添加在线预约信息
export function AddAppointment(params) {
    return fetch.post(`/api/public/YuYue/AddAppointment/?t=`+new Date().getTime(), params);
}
//获取在线预约结果列表
export function GetAppointmentByIdList(params) {
    return fetch.get(`/api/public/YuYue/GetAppointmentList/?t=`+new Date().getTime(), params);
}

//获取在线预约信息详情
export function GetAppointmentById(params) {
    return fetch.get(`/api/public/YuYue/GetAppointmentById/?t=`+new Date().getTime(), params);
}
// 取消预约
export function GetCancelById(params) {
    return fetch.get(`/api/public/YuYue/DelAppointmentById/?t=`+new Date().getTime(), params);
}
//获取仿真实验列表-无分页(获取实验列表-全部)
export function GetExperimentArr(params) {
    return fetch.get(`/api/public/General/GetExperimentArr/?t=`+new Date().getTime(), params)
}
//获取仿真实验列表-无分页(获取实验列表-学院)
export function GetExperimentList(params) {
    return fetch.get(`/api/public/General/GetExperimentList/?t=`+new Date().getTime(), params)
}
// 获取仿真实验学习资料列表
export function GetExpResourceList(params) {
    return fetch.get(`/api/public/Exp/GetExpResourceList/?t=`+new Date().getTime(), params)
}
// 获取进入虚拟仿真实验链接
export function GetExpUrl(params) {
    return fetch.get(`/api/public/Exp/GetExpUrl/?t=`+new Date().getTime(), params)
}
//新增假数据
export function submitGrade(params) {
    return fetch.post(`/api/public/Exp/AddScore/fake/?t=` + new Date().getTime, params);
}


// 获取学院列表
export function GetCollegeArr(params) {
    return fetch.get(`/api/public/General/GetCollegeList/?t=`+new Date().getTime(), params)
}
//教师设置学院班级
export function collegeClass(params) {
    return fetch.post(`/api/v1/teacher/college/class/change/?t=`+new Date().getTime(), params)
}
//教师获取学院班级
export function getCollegeClass(params) {
    return fetch.get(`/api/v1/teacher/college/class/change/?t=`+new Date().getTime(), params)
}
//学生获取学院班级
export function StGetCollegeClass(params) {
    return fetch.get(`/api/v1/student/college/class/change/?t=`+new Date().getTime(), params)
}
//学生设置学院班级
export function StGostCollegeClass(params) {
    return fetch.post(`/api/v1/student/college/class/change/?t=`+new Date().getTime(), params)
}
// 获取学院班级列表(参数)
export function GetClassArr(params) {
    return fetch.get(`/api/v1/admin/Class/GetClassIdList/?t=`+new Date().getTime(), params)
}